module.exports = __webpack_public_path__ + "img/20190712164311QQ截图20190712015639.5e360689.png";